<template>
  <div class='wizard__container'>
    <h2>1. Upload file to import</h2>
    <div class='wizard__description'>
      Need a template? Download one from the <a href='/admin/imports'>imports page</a>.
    </div>
    <form ref="form" @submit.prevent="submitForm" class='wizard__form'>
      <div class='form-group'>
        <label for='import_type'>Import Type</label>
        <select id='import_type' v-model='import_type'>
          <option value='Companies'>Companies</option>
          <option value='Knowledge Base Articles'>Knowledge Base Articles</option>
          <option value='Passwords'>Passwords</option>
          <option value='BlankAssetLayout'>Create a New Asset Layout</option>
          <option v-for='asset_layout in asset_layouts' :value='asset_layout[0]'>{{asset_layout[1]}}</option>
        </select>
      </div>

      <div class='wizard__description' v-if='import_type == "Companies"'>Companies match on name. Don't import companies that will be synced through an integration.</div>
      <div class='wizard__description' v-if='import_type == "Knowledge Base Articles"'>Knowledge Base Articles do not match, they will always create a new Article.</div>
      <div class='wizard__description' v-if='import_type == "Passwords"'>Passwords do not match, they will always create a new Password.</div>
      <div class='wizard__description' v-if='import_type == "BlankAssetLayout"'>This will create a new Asset Layout then create new Assets in the Asset Layout. All field types will be text. Field types can be updated afterward in Admin/Asset Layouts. If the Asset's Company name is not present or a company with a matching name is not found, the Asset will not be created. We do not recommend importing asset info that will be pulled from integrations.</div>
      <div class='wizard__description' v-if='import_type != "Companies" && import_type != "Knowledge Base Articles" && import_type != "Passwords" && import_type != "BlankAssetLayout" '>This will create new Assets in an existing Asset Layout. If there are validation rules that are not met, the Asset will not insert. If the Asset's Company name is not present or a company with a matching name is not found, the Asset will not be created. We do not recommend importing asset info that will be pulled from integrations.</div>

      <div class='form-group' v-if='import_type == "BlankAssetLayout"'>
        <label for='asset_layout_name' :class="{ required: isBlankAssetLayout }">Name of Asset Layout</label>
        <input type='text' placeholder="e.g. Network Devices" id='asset_layout_name' v-model='asset_layout_name' :required='isBlankAssetLayout'>
      </div>
      <div class='form-group'>
        <label for='file'>File for Import</label>
        <input id='file' type="file" @change="filesChange" accept=".csv" class="input-file">
      </div>
      <ul class='importer__errors'>
        <li v-for='error in errors'>Row {{error.row }}: {{error.message}}</li>
      </ul>
      <div v-if='ready'>
        <h2>2. Preview import</h2>
        <preview :data="data" :meta="meta"></preview>
        <div class="form-group">
          <button type="submit" class="button button--primary">
            Start Import
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import Papa from "papaparse";
  import Preview from "./Preview.vue"

  export default {
    props: ["asset_layouts", "url"],
    components: {
      Preview
    },
    computed: {
      isBlankAssetLayout() {
        return this.import_type === "BlankAssetLayout";
      }
    },
    methods: {
      submitForm () {
        if (!this.$refs.form.checkValidity()) {
          this.$refs.form.reportValidity() 
          return
        }

        this.$api.post(this.url, {
          import: {
            import_type: this.import_type,
            data: this.data,
            asset_layout_name: this.asset_layout_name,
            matching: this.matching
          }
        }).catch(error => console.log(error))
          .then(() => window.location.reload())
      },
      filesChange (e) {
        var that = this;
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
        that.file = files[0]

        Papa.parse(this.file,
          {
            delimiter: "",  // auto-detect
            newline: "",  // auto-detect
            quoteChar: '"',
            escapeChar: '"',
            header: true,
            transformHeader: undefined,
            dynamicTyping: false,
            preview: 0,
            encoding: "",
            worker: false,
            comments: false,
            step: undefined,
            complete: function(results, file) {
              that.data = results.data;
              that.meta = results.meta;
              that.errors = results.errors;
              that.ready = true;
            },
            error: undefined,
            download: false,
            downloadRequestHeaders: undefined,
            skipEmptyLines: true,
            chunk: undefined,
            fastMode: undefined,
            beforeFirstChunk: undefined,
            withCredentials: undefined,
            transform: undefined,
            delimitersToGuess: [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP]
          })
      }
    },
    data () {
      return {
        slide: 0,
        file: '',
        meta: [],
        ready: false,
        fileUploaded: false,
        data: [],
        import_type: "Companies",
        errors: [],
        asset_layout_name: ""
      }
    }
  }
</script>

<style scoped>

</style>
